import React from 'react';

export const HONEYPOT_FIELD_NAME = 'submission_reference_note';

const honeypotStyle = {
  position: 'absolute',
  left: '-10000px',
  top: 'auto',
  width: '1px',
  height: '1px',
  overflow: 'hidden',
  opacity: 0,
  pointerEvents: 'none'
};

export const getHoneypotValue = (form) => {
  const field = form?.elements?.namedItem?.(HONEYPOT_FIELD_NAME);
  return typeof field?.value === 'string' ? field.value.trim() : '';
};

export const isHoneypotSubmission = (form) => Boolean(getHoneypotValue(form));

export const withHoneypotValue = (values, form) => {
  const value = getHoneypotValue(form);

  if (values instanceof URLSearchParams) {
    values.set(HONEYPOT_FIELD_NAME, value);
    return values;
  }

  return { ...values, [HONEYPOT_FIELD_NAME]: value };
};

const HoneypotField = () => (
  <label style={honeypotStyle} aria-hidden="true">
    Submission reference note
    <input
      type="text"
      name={HONEYPOT_FIELD_NAME}
      defaultValue=""
      tabIndex={-1}
      autoComplete="off"
      data-1p-ignore="true"
      data-lpignore="true"
    />
  </label>
);

export default HoneypotField;
